import axios from 'Axios';

export default {
  getMyInfo() {
    return axios.get('/my_email');
  },
  getNotificationSettings() {
    return axios.get('/notification_settings');
  },
  deactivateAcc() {
    return axios.put('/deactivate');
  },
  postNewEmail(data) {
    return axios.post('/account/change_email', data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
  postNewPassword(data) {
    return axios.post('/account/change_password', data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
  postNotificationSettings(data) {
    return axios.post('/notification_settings', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
